module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_2.8cbe39ba.png";